import { api, setConfig } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const deactivateGames = (data: PropertyType): Promise<string | void> =>
	api.post('/games/disable', mapEntityToApi(data), setConfig(data)).then(() => {
		return 'The games have been successfully disabled ';
	});
